/**
 * Color Swatch Mephisto — Hover Image Swap
 *
 * Au survol d'une pastille couleur sur une card produit en page collection,
 * remplace l'image principale de la card par celle de la couleur survolée
 * (provient de l'attribut data-swatch-image écrit par le snippet
 * color-swatch-pastilles.liquid).
 *
 * Utilise une délégation d'événement sur document pour fonctionner même
 * sur les cards chargées dynamiquement (filtres, pagination AJAX).
 */
(function () {
  'use strict';

  function findCard(el) {
    return el.closest('product-card') || el.closest('.product-card');
  }

  function findMainImage(card) {
    if (!card) return null;
    var media = card.querySelector('.product-card__media');
    if (!media) return null;
    // On prend la première <img> visible — c'est l'image principale.
    // Les images "hover" / variantes secondaires sont après.
    var imgs = media.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].offsetParent !== null || imgs[i].classList.contains('hidden') === false) {
        return imgs[i];
      }
    }
    return imgs[0] || null;
  }

  function swapToSwatchImage(link) {
    var newSrc = link.getAttribute('data-swatch-image');
    if (!newSrc) return;
    var card = findCard(link);
    if (!card) return;
    var img = findMainImage(card);
    if (!img) return;

    // Sauvegarde des sources d'origine la première fois
    if (img.dataset.swatchOriginalSrc === undefined) {
      img.dataset.swatchOriginalSrc = img.getAttribute('src') || '';
      img.dataset.swatchOriginalSrcset = img.getAttribute('srcset') || '';
    }

    img.setAttribute('src', newSrc);
    // On vide le srcset pour empêcher le navigateur de revenir à l'image responsive d'origine
    img.setAttribute('srcset', '');
  }

  function restoreOriginalImage(link) {
    var card = findCard(link);
    if (!card) return;
    var img = findMainImage(card);
    if (!img) return;
    if (img.dataset.swatchOriginalSrc === undefined) return;

    img.setAttribute('src', img.dataset.swatchOriginalSrc);
    if (img.dataset.swatchOriginalSrcset) {
      img.setAttribute('srcset', img.dataset.swatchOriginalSrcset);
    } else {
      img.removeAttribute('srcset');
    }
  }

  // Délégation : mouseover/mouseout bubble correctement, mais on doit filtrer
  // les transitions internes au même <a>.
  document.addEventListener(
    'mouseover',
    function (e) {
      var link =
        e.target && e.target.closest && e.target.closest('.color-swatch-pastilles__link');
      if (!link) return;
      // Si on entre dans un descendant du même link, on ignore (pas une vraie entrée)
      if (e.relatedTarget && link.contains(e.relatedTarget)) return;
      swapToSwatchImage(link);
    },
    false
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var link =
        e.target && e.target.closest && e.target.closest('.color-swatch-pastilles__link');
      if (!link) return;
      // Si on sort vers un descendant du même link, on ignore
      if (e.relatedTarget && link.contains(e.relatedTarget)) return;
      restoreOriginalImage(link);
    },
    false
  );
})();
